import { DateTime } from "luxon";
import { UserLanguage } from "./types";

type LocalizedAppointmentDateDetails = {
    date: string;
    time: string;
};

type AppointmentDescriptionParts = {
    confirm: string;
    at: string;
};

export const getLocalizedAppointmentDateDetails = (
    appointmentDate: string,
    language: UserLanguage
): LocalizedAppointmentDateDetails | null => {
    if (!appointmentDate) {
        return null;
    }

    const parsedAppointmentDate = DateTime.fromISO(appointmentDate);

    if (!parsedAppointmentDate.isValid) {
        return null;
    }

    const localizedAppointmentDate = parsedAppointmentDate.setLocale(
        `${language}-CA`
    );

    const date = localizedAppointmentDate.toLocaleString(DateTime.DATE_FULL);
    const time = localizedAppointmentDate.toLocaleString(DateTime.TIME_SIMPLE);
    return {
        date,
        time,
    };
};

export const buildReservedAppointmentDescription = (
    appointmentDate: string | undefined,
    clinicName: string | undefined,
    language: UserLanguage,
    descriptionParts: AppointmentDescriptionParts
): string | null => {
    if (!appointmentDate || !clinicName) {
        return null;
    }

    const appointmentDateDetails = getLocalizedAppointmentDateDetails(
        appointmentDate,
        language
    );

    if (!appointmentDateDetails) {
        return null;
    }

    return [
        descriptionParts.confirm,
        appointmentDateDetails.date,
        `${descriptionParts.at} ${appointmentDateDetails.time}`,
        `${descriptionParts.at} ${clinicName}.`,
    ].join(" ");
};
